var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 294,
    viewBox: "0 0 315 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.6083,
    y: 23.1443,
    width: 247.711,
    height: 247.711,
    rx: 50,
    fill: "#6E44FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233.968,
    cy: 138.957,
    r: 80.5364,
    fill: "#FB9C46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.292 101.007C121.405 101.007 130.934 104.57 137.881 111.695C144.917 118.731 148.435 128.928 148.435 142.287V195.323H138.683V167.803H79.9022V195.323H70.2836V142.287C70.2836 128.928 73.757 118.731 80.7037 111.695C87.7396 104.57 97.2691 101.007 109.292 101.007ZM138.683 159.254V141.352C138.683 130.932 136.1 123.095 130.934 117.84C125.769 112.496 118.555 109.825 109.292 109.825C100.03 109.825 92.8161 112.496 87.6505 117.84C82.485 123.095 79.9022 130.932 79.9022 141.352V159.254H138.683Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.434 110.359V186.773H216.404V195.323H168.712V186.773H187.682V110.359H168.712V101.809H216.404V110.359H197.434Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.425 0.625122C104.535 0.625122 107.055 3.14567 107.055 6.25493L107.055 40.0337C107.055 43.143 104.535 45.6635 101.425 45.6635C98.3162 45.6635 95.7957 43.143 95.7957 40.0337L95.7957 6.25492C95.7957 3.14567 98.3162 0.625122 101.425 0.625122Z",
    fill: "#FB9C46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.425 248.336C104.535 248.336 107.055 250.857 107.055 253.966L107.055 287.745C107.055 290.854 104.535 293.375 101.425 293.375C98.3162 293.375 95.7957 290.854 95.7957 287.745L95.7957 253.966C95.7957 250.857 98.3162 248.336 101.425 248.336Z",
    fill: "#FB9C46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0891118 99.1466C0.0891115 96.0374 2.60966 93.5168 5.71891 93.5168L28.2381 93.5168C31.3474 93.5168 33.8679 96.0374 33.8679 99.1466C33.8679 102.256 31.3474 104.776 28.2381 104.776L5.71892 104.776C2.60966 104.776 0.0891121 102.256 0.0891118 99.1466Z",
    fill: "#FB9C46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0891118 144.185C0.0891115 141.076 2.60966 138.555 5.71891 138.555L39.4977 138.555C42.607 138.555 45.1275 141.076 45.1275 144.185C45.1275 147.294 42.607 149.815 39.4977 149.815L5.71892 149.815C2.60966 149.815 0.0891121 147.294 0.0891118 144.185Z",
    fill: "#FB9C46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0891118 189.224C0.0891115 186.114 2.60966 183.594 5.71891 183.594L33.8679 183.594C36.9772 183.594 39.4977 186.114 39.4977 189.224C39.4977 192.333 36.9772 194.853 33.8679 194.853L5.71892 194.853C2.60966 194.853 0.0891121 192.333 0.0891118 189.224Z",
    fill: "#FB9C46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.464 0.625122C149.573 0.625122 152.094 3.14567 152.094 6.25493L152.094 31.589C152.094 34.6983 149.573 37.2188 146.464 37.2188C143.355 37.2188 140.834 34.6983 140.834 31.589L140.834 6.25492C140.834 3.14567 143.355 0.625122 146.464 0.625122Z",
    fill: "#FB9C46"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.464 253.966C149.573 253.966 152.094 256.487 152.094 259.596L152.094 284.93C152.094 288.039 149.573 290.56 146.464 290.56C143.355 290.56 140.834 288.039 140.834 284.93L140.834 259.596C140.834 256.487 143.355 253.966 146.464 253.966Z",
    fill: "#FB9C46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.502 0.625122C194.612 0.625122 197.132 3.14567 197.132 6.25492L197.132 28.7741C197.132 31.8834 194.612 34.4039 191.502 34.4039C188.393 34.4039 185.873 31.8834 185.873 28.7741L185.873 6.25492C185.873 3.14567 188.393 0.625122 191.502 0.625122Z",
    fill: "#FB9C46"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.502 256.781C194.612 256.781 197.132 259.302 197.132 262.411L197.132 284.93C197.132 288.039 194.612 290.56 191.502 290.56C188.393 290.56 185.873 288.039 185.873 284.93L185.873 262.411C185.873 259.302 188.393 256.781 191.502 256.781Z",
    fill: "#FB9C46"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.248,
    cy: 63.2478,
    r: 20.0307,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigs);
export default __webpack_public_path__ + "static/media/configs.4c785fff5fe56a7b404e3165417ac2b6.svg";
export { ForwardRef as ReactComponent };